module.exports = __webpack_public_path__ + "img/selected1-min.ee9220ba.png";